// src/store.js
import { reactive } from 'vue';

export const globalState = reactive({
  // Map to store the selected item for each radio group (optional persistence)
  radioGroupStates: JSON.parse(localStorage.getItem('radioGroupStates')) || {},

  getRadioGroupState(groupId, defaultSelectedId = null) {
    if (!this.radioGroupStates[groupId]) {
      this.radioGroupStates[groupId] = defaultSelectedId;
      this.saveRadioGroupStates();
    }
    return this.radioGroupStates[groupId];
  },

  setRadioGroupState(groupId, itemId) {
    this.radioGroupStates[groupId] = itemId;
    this.saveRadioGroupStates();
  },

  saveRadioGroupStates() {
    localStorage.setItem('radioGroupStates', JSON.stringify(this.radioGroupStates));
  },

  // Existing state for editingDeviceId
  editingDeviceId: null,

  setEditingDeviceId(id) {
    this.editingDeviceId = id;
  },
  clearEditingDeviceId() {
    this.editingDeviceId = null;
  },
});